import { Controller } from "@hotwired/stimulus";
import { i18n } from "../lib/i18n";

export default class extends Controller {
  static targets = ["elapsedTime", "progressBar", "totalTime"];
  static values = {
    startedAt: String,
    durationMinutes: Number
  };

  declare elapsedTimeTarget: HTMLElement;
  declare progressBarTarget: HTMLProgressElement;
  declare totalTimeTarget: HTMLElement;
  declare startedAtValue: string;
  declare durationMinutesValue: number;
  declare hasStartedAtValue: boolean;
  declare hasDurationMinutesValue: boolean;
  declare hasElapsedTimeTarget: boolean;
  declare hasProgressBarTarget: boolean;
  private timerInterval: number | undefined;

  connect() {
    if (this.hasStartedAtValue) {
      this.startTimer();
    }
  }

  disconnect() {
    this.stopTimer();
  }

  startTimer() {
    this.updateTimer();
    this.timerInterval = window.setInterval(() => {
      this.updateTimer();
    }, 10000);
  }

  stopTimer() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  updateTimer() {
    const startedAt = new Date(this.startedAtValue);
    const now = new Date();
    let totalDurationMs = 0;
    if (this.hasDurationMinutesValue) {
      totalDurationMs = this.durationMinutesValue * 60 * 1000;
    }
    const elapsedMs = now.getTime() - startedAt.getTime();

    // Calculate elapsed minutes
    const elapsedMinutes = Math.floor(elapsedMs / (1000 * 60));
    let isOverdue = false;
    if (this.hasDurationMinutesValue) {
      isOverdue = elapsedMinutes > this.durationMinutesValue;
    }

    // Update elapsed time text
    if (this.hasElapsedTimeTarget) {
      if (this.hasDurationMinutesValue) {
        if (isOverdue) {
          const overdueMinutes = elapsedMinutes - this.durationMinutesValue;
          this.elapsedTimeTarget.innerHTML = i18n.t('service_timer.overdue_by', { minutes: overdueMinutes });
          this.elapsedTimeTarget.classList.add("text-red-500", "font-medium");
          this.elapsedTimeTarget.classList.remove("text-gray-500");
        } else {
          this.elapsedTimeTarget.innerHTML = i18n.t('service_timer.elapsed_of_total', { elapsed: elapsedMinutes, total: this.durationMinutesValue });
          this.elapsedTimeTarget.classList.remove(
            "text-red-500",
            "font-medium",
          );
          this.elapsedTimeTarget.classList.add("text-gray-500");
        }
      } else {
        this.elapsedTimeTarget.innerHTML = i18n.t('service_timer.elapsed_mins', { elapsed: elapsedMinutes });
        this.elapsedTimeTarget.classList.remove("text-red-500", "font-medium");
        this.elapsedTimeTarget.classList.add("text-gray-500");
      }
    }

    // Calculate and update progress percentage
    if (this.hasProgressBarTarget) {
      const progressPercentage = Math.min(
        100,
        (elapsedMs / totalDurationMs) * 100,
      );
      this.progressBarTarget.value = progressPercentage;
    }
  }
}

